import { useTranslation } from "react-i18next";
import { Button } from "~/components/button";
import { Text } from "~/components/text";

interface TableFooterProps {
  showPipelineInfoButton: boolean;
  onPipelineInfoOpen?: () => void;
}

export const TableFooter = ({
  showPipelineInfoButton,
  onPipelineInfoOpen,
}: TableFooterProps) => {
  const { t } = useTranslation(["components", "general"]);

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-primary-25 border-t border-secondary-200">
      <div className="flex items-center gap-2">
        <div className="flex flex-col">
          <Text as="span" variant="label">
            {t("components:keywordsTab.unifiedKeywordsTable.footer.title")}
          </Text>
          <Text as="span" variant="caption">
            {t(
              "components:keywordsTab.unifiedKeywordsTable.footer.description",
            )}
          </Text>
        </div>
      </div>
      {showPipelineInfoButton && onPipelineInfoOpen && (
        <div className="flex items-center gap-3">
          <Button
            icon="circle-question-mark"
            variant="tertiary"
            size="small"
            onClick={onPipelineInfoOpen}
            analyticsId="button_pipeline_info"
            className="size-8 flex items-center justify-center"
          />
        </div>
      )}
    </div>
  );
};
